const STORAGE_KEY = 'dyna_cookie_consent';

// 'accepted' | 'declined' | null (no choice made yet — banner should show)
export const getConsent = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore storage failures (private browsing, quota, etc.)
  }
};
